// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead___xTqO","bigColWidth":"Table_bigColWidth__2G8lI","biggerColWidth":"Table_biggerColWidth__M56aS","row":"Table_row__10AfN","col":"Table_col__3xLGd"};